
/*adds sale tags if a product is on sale*/
function addSaleTags(snizeUl){
  console.log('added sale tags');
  //console.log(snizeUl);
  
  //set initial vars
  var ct_price, ct_sale_price, discount, price_counter;
  var regex = /\D+/g;
  
  for(var i = 0; i < snizeUl.length; i++){
    //check to see if there is a discounted price on the product card
    price_counter = snizeUl[i].querySelectorAll('.snize-price-list span').length;
    
    if(price_counter == 1){
      //skip this case
    } else {
      //add a discount tag
      //set initial vars
      ct_price = snizeUl[i].querySelector('span.snize-discounted-price.money').innerText;
      ct_price = ct_price.replace(regex, '');
      ct_sale_price = snizeUl[i].querySelector('span.snize-price-with-discount.money').innerText;
      ct_sale_price = ct_sale_price.replace(regex, '');
      discount = Math.floor( ( 1-(ct_sale_price/ct_price) ) *100);
      //console.log(discount+'%');

      //set the discount span in the parent element
      let discountSpan = document.createElement("span");
      let discountWrapperDiv = document.createElement("div");
      discountSpan.innerText = discount+"% off";
      discountWrapperDiv.classList.add("ct-sale-tag");
      discountWrapperDiv.appendChild(discountSpan);
      snizeUl[i].querySelector('div.snize-item.clearfix').appendChild(discountWrapperDiv);
    }
  }
}

//event listener function
function addCtEventListeners(filters){
  if(filters.length == 0){
    //do nothing
  } else {
    var x = 0;
    do{
      //console.log(filters[x]);
      filters[x].addEventListener("mouseup", reloadSaleTags);
      x++;
    } while (x < filters.length);
  }
}

//event listener function
function addEventListenersInputs(inputs){
  var i = 0;
  do{
    inputs[i].addEventListener("change", reloadSaleTags);
    i++;
  } while (i < inputs.length);
}


function reloadSaleTags(){
  var snizeLoaded = setInterval(function() {
    attempt_count ++;
    var snizeResults = document.querySelectorAll('ul.snize-search-results-content.clearfix li');
    
    //failsafe
    if( attempt_count > 9){
      console.log('cleared everything');
      clearInterval(snizeLoaded);
    }

    if( snizeResults.length > 0 ){

      addSaleTags(snizeResults);
      //addVarImages(snizeResults);

      var searchanizeFilters = document.querySelectorAll('ul.snize-product-filters-list li');
      var searchanizeInputs = document.querySelectorAll('input.snize-price-range-input');
      var searchanizeButtons = document.querySelectorAll('ul.snize-product-size-filter div.snize-size-filter-checkbox');
      var searchanizeFilterResets = document.querySelectorAll('.snize-product-filters-reset');
      addCtEventListeners(searchanizeFilterResets);
      addCtEventListeners(searchanizeFilters);
      addCtEventListeners(searchanizeButtons);
      addEventListenersInputs(searchanizeInputs);

      //clear the interval so it doesn't run again
      clearInterval(snizeLoaded);
    }
  },300);
}

function delayLoadSaleTags(time){
  setTimeout(function(){
    var snizeResults = document.querySelectorAll('ul.snize-search-results-content.clearfix li');
    addSaleTags(snizeResults);
    //addVarImages(snizeResults);

    var searchanizeFilters = document.querySelectorAll('ul.snize-product-filters-list li');
    var searchanizeInputs = document.querySelectorAll('input.snize-price-range-input');
    var searchanizeButtons = document.querySelectorAll('ul.snize-product-size-filter div.snize-size-filter-checkbox');
    var searchanizeFilterResets = document.querySelectorAll('.snize-product-filters-reset');
    addCtEventListeners(searchanizeFilterResets);
    addCtEventListeners(searchanizeFilters);
    addCtEventListeners(searchanizeButtons);
    addEventListenersInputs(searchanizeInputs);

    //clear the interval so it doesn't run again
    clearInterval(snizeLoaded);
  }, time);
}

// create an Observer instance
//const resizeObserver = new ResizeObserver(entries => 
//  console.log('Body height changed:', entries[0].target.clientHeight)                                        
//)

const resizeObserver = new ResizeObserver(entries => delayLoadSaleTags(1000) )


// start observing a DOM node
resizeObserver.observe(document.body)


//Functions for image variants...
/*

//function to loop through the searchanize results on a page and insert variant images. 
function addVarImages(snizeUl){
  let regex = /products\/(.*)/g
  let regexTwo = /\/(.*)/g
  
  //check to see if image squares already exist (rare, but happens with certain form fields)
  var ctImageSquares = document.querySelectorAll('.ct-collection-img-wrapper');
  if(ctImageSquares.length == 0){
    var x = 0;
    do{
      //build the image element(s) depending on how many images there are. 
      //find out how many images there are
      //pull the current product
      var viewLink = snizeUl[x].querySelector('.snize-view-link').getAttribute("href");
      var productHandle = viewLink.match(regex);
      productHandle = productHandle[0].match(regexTwo);

      //query the products API to get variants
      insertCollectionImages(productHandle[0], x, snizeUl);
      x++;
    } while (x < snizeUl.length);
  }
  retrospectiveDupCheck();
}



function insertCollectionImages(handle, order, snizeUl){
  let regExHandleFilter = /\?(.*)/g;
  handle = handle.replace(regExHandleFilter,"");
  jQuery.getJSON('/products/'+handle+'.js', function(product) {
    let price = snizeUl[order].querySelector('.snize-price-list');
    let imgSpan = document.createElement("span");
    let regEx = /.png\?/g; // regex to add _thumb to the url string so we can load smaller images below. 
    imgSpan.classList.add("ct-collection-img-wrapper");
    price.appendChild(imgSpan);
    var i = 0;
    var option1 = null;
    do{
      if( product.variants[i].option1 == null && product.type != "Gift Card" ){
        option1 = product.variants[i].option1;
        var imgSrc = product.variants[i].featured_media.preview_image.src;
        imgSrc = imgSrc.replace(regEx, "_small.png?");
        insertImage(imgSrc, order, snizeUl, imgSpan, handle, product.variants[i]);
      } else if (product.variants[i].option1 != option1 && product.type != "Gift Card"){
        option1 = product.variants[i].option1;
        var imgSrc = product.variants[i].featured_media.preview_image.src;
        imgSrc = imgSrc.replace(regEx, "_small.png?");
        insertImage(imgSrc, order, snizeUl, imgSpan, handle, product.variants[i]);
      }
      i++;
    } while (i < product.variants.length);
    
  } );
}

function insertImage(imgSrc, order, snizeUl, imgSpan, handle, variantObj){
  let imgElement = document.createElement("img");
  imgElement.classList.add("ct-collection-addition");
  imgSpan.appendChild(imgElement);
  imgElement.src = imgSrc;
}

function reloadImageSquares(){
  var snizeLoaded = setInterval(function() {
    var snizeResults = document.querySelectorAll('ul.snize-search-results-content.clearfix li');
    if(snizeResults.length > 0){
      addVarImages(snizeResults);
      var searchanizeFilters = document.querySelectorAll('ul.snize-product-filters-list li');
      var searchanizeInputs = document.querySelectorAll('input.snize-price-range-input');
      var searchanizeButtons = document.querySelectorAll('ul.snize-product-size-filter div.snize-size-filter-checkbox');
      var searchanizeFilterResets = document.querySelectorAll('.snize-product-filters-reset');
      addCtEventListeners(searchanizeFilterResets);
      addCtEventListeners(searchanizeFilters);
      addCtEventListeners(searchanizeButtons);
      addEventListenersInputs(searchanizeInputs);
      clearInterval(snizeLoaded);
    }
  },300);
}


function retrospectiveDupCheck(){
  setTimeout(function(){
    var ctImageSquares = document.querySelectorAll('.ct-collection-img-wrapper');
    var snizeResults = document.querySelectorAll('ul.snize-search-results-content.clearfix li');
    if(ctImageSquares.length == snizeResults.length){
      //console.log('no dup detected');
      //console.log(ctImageSquares.length);
      //console.log(snizeResults.length);
      //console.log(snizeResults);
    } else if (ctImageSquares.length > snizeResults.length) {
      //console.log('dup detected');
      //console.log(ctImageSquares.length);
      //console.log(snizeResults.length);
      
      //loop through each snizeResult
      //snag the local image squares and add a ct-hidden class to any dups. 
      var x = 0;
      do{
        var ctImageSquareLocal = snizeResults[x].querySelectorAll('.ct-collection-img-wrapper');
        var i = 1;
        do{
          ctImageSquareLocal[i].classList.add('ct-hidden');
          i++;
        } while (i < ctImageSquareLocal.length);
        x++;
      } while (x < snizeResults.length);
    } else {
      //console.log('fewer image squares detected');
    }
  },1000)
}

*/